module.exports = __webpack_public_path__ + "static/media/auth-step-3.f89d76f0.svg";